import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useStore } from 'vuex';
import { showToast } from 'vant';
import { useI18n } from 'vue-i18n';
import layout from './views/layout';
import { v4 as uuidv4 } from 'uuid';
import { Bridge } from '@/utils/bridge';
import { useLess } from '@/models/hooks';
import { useRouter, useRoute } from 'vue-router';
import { computed, onMounted, ref, watch } from 'vue';
import { clearInvalidDataFromCart, parseAndOpenUrl } from '@/utils/common';
import constants, { encryptedMarketplaceId } from '@/constants';
import { isPrimaryPage } from '@/router/index';
import { SET_AGENT_DATA } from '@/store/mutations.types';
import { isAppEnvIos } from '@/utils/device';
import { isShowPIPLConfirmAlertView } from '@/utils/common';
var __default__ = {
  name: 'IndexLayout'
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    var marketPlaceStyleMap = constants.marketPlaceStyleMap,
      TABBAR_PAGE_APP_CODE = constants.TABBAR_PAGE_APP_CODE,
      DOCUMENT_TITLE = constants.DOCUMENT_TITLE;
    var mainClass = ref('cn-app');
    // Handling special styles
    var initMainAppStyle = () => {
      mainClass.value = `${marketPlaceStyleMap[encryptedMarketplaceId]}-app`;
      useLess('views/App.less');
    };
    var router = useRouter();
    var route = useRoute();
    var _useI18n = useI18n(),
      t = _useI18n.t;

    // Introducing the store library
    var store = useStore();
    // main content padding top
    var phoneContentTopHeight = computed(() => {
      var _store$state$navigato;
      return (_store$state$navigato = store.state.navigator.phoneContentTopHeight) !== null && _store$state$navigato !== void 0 ? _store$state$navigato : 0;
    });
    var isLoading = ref(false);
    var isCartMaxLimit = ref(false);

    // Display pop-up prompt when the number of shopping carts reaches the maximum limit
    watch(() => store.state.cart.isCartMaxLimit, value => {
      isCartMaxLimit.value = value;
    });
    // Close pop-up synchronization to change status
    watch(isCartMaxLimit, value => {
      store.commit('cart/setCartMaxLimitStatus', value);
    });
    var goToCart = () => {
      if (route.name === 'cart') {
        router.push({
          name: 'cart',
          query: {
            // Passing a uuid ensures that the value changes every time
            scrollToTop: uuidv4()
          }
        });
        store.commit('cart/setCartMaxLimitStatus', false);
        // Passing a uuid ensures that the value changes every time
        store.commit('cart/setCloseBuyingOptionsPopup', uuidv4());
        return;
      }
      Bridge.callFn('getWebViewOriginalPagePath', {}, ({
        path
      }) => {
        router.push(path);
      });
      Bridge.callFn('changeTabbarSelectItem', {
        selectIndex: TABBAR_PAGE_APP_CODE.CART
      }, () => {});
    };
    var onOneClickCartCleaning = () => {
      isLoading.value = true;
      clearInvalidDataFromCart(data => {
        isLoading.value = false;
        if (data.status) {
          showToast({
            message: `${data.count}${t('modules.cart.INELIGIBLE_PRODUCT_CLEAR_SUCCESSFUL')}`,
            className: 'a-toast'
          });
          store.commit('cart/setCurrentCartRefreshStatus', true);
        } else {
          store.commit('cart/setCartMaxLimitStatus', true);
          showToast({
            message: t('modules.cart.NO_SPACE_TO_CLEAR'),
            className: 'a-toast'
          });
        }
      });
    };
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            document.title = DOCUMENT_TITLE;
            store.commit(`navigator/${SET_AGENT_DATA}`);
            _context3.t0 = store;
            _context3.next = 5;
            return isShowPIPLConfirmAlertView(false);
          case 5:
            _context3.t1 = !_context3.sent;
            _context3.t0.commit.call(_context3.t0, 'common/setPIPLAuthorizedStatus', _context3.t1);
            if (isAppEnvIos()) {
              /**
               * controlWebViewBounces
               * Control the drag and drop effects of bounces on the current webview, IOS only
               * Gswebapp turns off this effect, amz wants this effect
               */
              Bridge.callFn('controlWebViewBounces', {
                enable: false
              }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              })));
              Bridge.callFn('getAppTabbarHeight', {}, /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(result) {
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        store.commit(`common/getTabbarHeight`, result.height);
                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());
            }
            window.onpageshow = () => {
              var path = router.currentRoute.value;
              if (!path.name) return;
              var isPrimaryPageVal = isPrimaryPage(path);
              Bridge.callFn('bottomBarStatusChange', {
                show: isPrimaryPageVal
              });
            };
            Bridge.registerFn('onOpenUrlProvidedByNative', res => {
              var url = res.url;
              parseAndOpenUrl(router, url);
            });
          case 10:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    initMainAppStyle();
    return (_ctx, _cache) => {
      var _component_pop_up = _resolveComponent("pop-up");
      var _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        id: "app",
        class: _normalizeClass(["main-app", [mainClass.value]]),
        style: _normalizeStyle({
          'padding-top': phoneContentTopHeight.value + 'px'
        })
      }, [_withDirectives(_createVNode(_unref(layout), null, null, 512), [[_directive_loading, isLoading.value]])], 6), _createVNode(_component_pop_up, {
        class: "cart-max-limit-pop-up",
        show: isCartMaxLimit.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => isCartMaxLimit.value = $event),
        title: _unref(t)('modules.cart.SHOPPING_CART_FULL_PROMPT'),
        btnConfirmText: _unref(t)('modules.cart.ONE_CLICK_CLEAR'),
        btnCancelShow: true,
        isOverCartMaxLimit: true,
        btnCancelText: _unref(t)('modules.cart.GO_TO_CART'),
        onClose: goToCart,
        onConfirm: onOneClickCartCleaning
      }, null, 8, ["show", "title", "btnConfirmText", "btnCancelText"])], 64);
    };
  }
});